// medpdb2.EAN holds product codes — GS1 EANs commonly, 7-digit Swedish
// varunummer, and zero-padded 15-digit GTINs (prod survey 2026-07-17: 5.9%
// non-GS1, 139 rows with live analytics data). That survey read stored keys,
// which carry a masking digit; a real code is one digit shorter, so the domain
// range is 6-15 (prod survey 2026-08-31). The guard is digits-only and rejects
// only junk/malformed values outside that range; stricter enforcement is
// deferred to scraper-side normalization.
export type EAN = string & { readonly __brand: 'EAN' };

const EAN_PATTERN = /^\d{6,15}$/;

export function EAN(raw: string): EAN {
  const normalized = raw.trim();
  if (!EAN_PATTERN.test(normalized)) {
    throw new Error(`Invalid EAN: "${raw}" (expected 6-15 digits)`);
  }
  return normalized as EAN;
}

/**
 * Boundary parser for external data (medpdb2, portal_org) that holds product
 * codes — GS1 EANs, 7-digit Swedish varunummer, and zero-padded 15-digit
 * GTINs (prod survey 2026-07-17), each one digit shorter once unmasked. Returns
 * null instead of throwing so a single junk/malformed row outside the 6-15-digit
 * range can't crash a whole batch.
 */
export function tryEAN(raw: string): EAN | null {
  const normalized = raw.trim();
  return EAN_PATTERN.test(normalized) ? (normalized as EAN) : null;
}
